<template>
  <a-layout>
    <a-space>
      <a-input v-model="query['item.no']" :placeholder="$t('business.label.itemNo')" allowClear class="query" @pressEnter="search()"/>
      <a-input v-model="query['item.name']" :placeholder="$t('business.label.itemName')" allowClear class="query" @pressEnter="search()"/>
      <a-input v-model="query['lot.no']" :placeholder="$t('business.label.lot')" allowClear class="query" @pressEnter="search()"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="search()"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="error" @click="reset"/>
      <vxe-button content="button.modify" size="mini" status="primary" @click="modify"/>
      <vxe-button content="button.rollback" size="mini" status="error" @click="rollback"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="lot.no" title="business.label.lot" width="150"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="detail.receivingman" title="business.label.receiver" width="150"/>
      <vxe-column field="detail.invoiceQuantity" title="business.label.invoiceQuantity" width="150"/>
      <vxe-column field="detail.receivedQuantity" title="business.label.receivedQuantity" width="150"/>
      <vxe-column field="detail.acceptedQuantity" title="business.label.acceptedQuantity" width="150"/>
      <vxe-column field="detail.rejectedQuantity" title="business.label.rejectedQuantity" width="150"/>
      <vxe-column field="detail.rejectedQuantityOfAcceptance" title="business.label.rejectedQuantityOfAcceptance" width="150"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <modify-modal ref="modifyModal" @success="success"/>
  </a-layout>
</template>
<script>
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import ModifyModal from '@/views/inbound/modify/ModifyModal.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ModifyDetail',
  components: { ModifyModal },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 15,
      contentSize: 0,
      query: {
        'item.no': '',
        'item.name': '',
        'lot.no': '',
        'no': ''
      },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.515)
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch(args) {
      if (args !== null && args !== undefined) {
        Object.assign(this.query, args)
      }
      if (this.query['no'] === '' || this.query['no'] === undefined || this.query['no'] === null) {
        return this.$message.warning('请先选择单据')
      }
      this.loading = true
      findAll('receiptDetailFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    clear() {
      this.data = []
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.query['no'] = ''
      this.page = 1
    },
    reset() {
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.page = 1
      this.fetch()
    },
    dblclick(row) {
      this.$refs.modifyModal.open(row)
    },
    modify() {
      let currentRow = this.$refs.table.getCurrentRecord()
      if (currentRow === null) {
        return this.$message.warning('请先选择需要调整的明细数据')
      }
      this.$refs.modifyModal.open(currentRow)
    },
    success() {
      this.fetch()
    },
    search() {
      this.page = 1
      this.fetch()
    },
    rollback() {
      let currentRow = this.$refs.table.getCurrentRecord()
      if (currentRow === null) {
        return this.$message.warning('请先选择需要调整的明细数据')
      }
      const that = this
      this.$confirm({
        title: '是否确认验收回滚?',
        content: '验收回滚后需重新验收',
        onOk() {
          that.loading = true
          return new Promise((resolve) => {
            post(Api.receivingReceiverRollback, {}, { id: currentRow.detail.id }).then(res => {
              if (res.success) {
                that.$message.success('回滚成功')
                that.fetch()
              }
              resolve()
            }).finally(() => that.loading = false)
          })
        },
        onCancel() {
        },
        centered: true
      })
    }
  }
}
</script>